import { render, staticRenderFns } from "./MergePending.vue?vue&type=template&id=55cdeab6&scoped=true&"
import script from "./MergePending.vue?vue&type=script&lang=js&"
export * from "./MergePending.vue?vue&type=script&lang=js&"
import style0 from "./MergePending.vue?vue&type=style&index=0&id=55cdeab6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55cdeab6",
  null
  
)

export default component.exports